import { DataManagingManager } from "src/modules/DataManagingManager/DataManagingManager";

export const DataManagingPage: React.FC = () => {
  return <DataManagingManager />;
};
